<app-pias-layout>
  <div pias-layout-content>
    @if(this.setSprinner()) {
    <div class="pias-spinner">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    }
    <br>
    @if (declarationData; as data) {

    <div class="page-header-section">

      <!-- Left Content -->
      <div class="page-header-left">

        <div class="title-wrapper">

          <h4 class="page-header">
            Annual Declaration
          </h4>
          @if(data.adStatus === 'Running' || data.adStatus === 'Not_Started' ){
          <div class="page-status-chip">

            <mat-icon>verified_user</mat-icon>

            <span>
              Initiated
            </span>
            <!-- <div class="meta-item"> -->
            <!-- <mat-icon>calendar_today</mat-icon> -->

            <span>
              {{ data.createdOn | date: 'dd MMM yyyy' }}
            </span>
            <!-- </div> -->

          </div>
          }
        </div>
      </div>

      <!-- Right Actions -->
      <div class="page-header-right">
        @if (data.adStatus === 'InValid') {
        <button color="primary" class="initiate-btn" (click)="openInitiateDialog()">

          <mat-icon>restart_alt</mat-icon>

          Initiate

        </button>
        }

      </div>

    </div>

    }
    <div class="container-fluid px-0">
      <div class="row g-2">

        <div class="col">
          <mat-card class="stat-card total" (click)="clickFilters('')">
            <mat-card-content>
              <div class="stat-top">
                <div class="stat-icon-wrap">
                  <mat-icon>description</mat-icon>
                </div>
              </div>
              <div class="stat-info">
                <p class="stat-label">Total Declarations</p>
                <h2 class="stat-value">{{this.totalCount}}</h2>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="col">
          <mat-card class="stat-card pending" (click)="clickFilters('NOT STARTED')">
            <mat-card-content>
              <div class="stat-top">
                <div class="stat-icon-wrap">
                  <mat-icon>pending_actions</mat-icon>
                </div>
              </div>
              <div class="stat-info">
                <p class="stat-label">Not Started</p>
                <h2 class="stat-value">{{notstartedcount}}</h2>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="col">
          <mat-card class="stat-card progress" (click)="clickFilters('IN PROGRESS')">
            <mat-card-content>
              <div class="stat-top">
                <div class="stat-icon-wrap">
                  <mat-icon>work</mat-icon>
                </div>
              </div>
              <div class="stat-info">
                <p class="stat-label">In Progress</p>
                <h2 class="stat-value">{{inprogresscount}}</h2>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="col">
          <mat-card class="stat-card returned" (click)="clickFilters('RETURNED')">
            <mat-card-content>
              <div class="stat-top">
                <div class="stat-icon-wrap">
                  <mat-icon>history</mat-icon>
                </div>
              </div>
              <div class="stat-info">
                <p class="stat-label">Returned</p>
                <h2 class="stat-value">{{retuenedcount}}</h2>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="col">
          <mat-card class="stat-card submitted" (click)="clickFilters('SUBMITTED')">
            <mat-card-content>
              <div class="stat-top">
                <div class="stat-icon-wrap">
                  <mat-icon>upload_file</mat-icon>
                </div>
              </div>
              <div class="stat-info">
                <p class="stat-label">Submitted</p>
                <h2 class="stat-value">{{submittedCount}}</h2>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="col">
          <mat-card class="stat-card review" (click)="clickFilters('IN REVIEW')">
            <mat-card-content>
              <div class="stat-top">
                <div class="stat-icon-wrap">
                  <mat-icon>fact_check</mat-icon>
                </div>
              </div>
              <div class="stat-info">
                <p class="stat-label">In Review</p>
                <h2 class="stat-value">{{inreviewcount}}</h2>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="col">
          <mat-card class="stat-card approved" (click)="clickFilters('APPROVED')">
            <mat-card-content>
              <div class="stat-top">
                <div class="stat-icon-wrap">
                  <mat-icon>verified</mat-icon>
                </div>
              </div>
              <div class="stat-info">
                <p class="stat-label">Approved</p>
                <h2 class="stat-value">{{approvedcount}}</h2>
              </div>
            </mat-card-content>
          </mat-card>
        </div>

      </div>
    </div>

    <div class="tab-content">
      <mat-card class="table-card">
        <!-- Search Section -->
        <div class="search-section">
          <div class="table-toolbar">
            <div id="recipient-filter-form" class="w-100">
              <form class="row align-items-start g-3">
                <!-- Search Input -->
                <div class="col-sm-12 col-md-6 col-lg-5 col-xxl-5 m-0">
                  <div class="position-relative" style="max-width: 500px">
                    <input #searchInput type="text" class="form-control border-0 shadow-sm pe-10"
                      style="background: #f0f0f0; color: #1c3a7a" placeholder="Search"
                      (keyup)="_onSearchRecipients($event)" />

                    <!-- Search icon -->
                    <i class="fas fa-search position-absolute top-50 start-0 ms-3 translate-middle-y"
                      style="color: #888888"></i>

                    <!-- Clear button -->
                    <button *ngIf="searchInput.value" type="button"
                      class="btn position-absolute top-50 end-0 translate-middle-y me-1 p-3 border-0 bg-transparent"
                      style="z-index: 100; cursor: pointer" (click)="searchInput.value = ''; _clearRecipientSearch()">
                      <i class="fas fa-times" style="color: #888888; pointer-events: none"></i>
                    </button>
                  </div>
                </div>
              </form>
              <!-- Changes Filter -->
              <div class="col-sm-12 col-md-3 col-lg-2 col-xxl-2 me-2">
                <!-- <mat-label class="field-label">Status Filter</mat-label> -->
                <mat-form-field class="w-100">
                  <mat-select name="selectedChanges" [(ngModel)]="selectedChanges"
                    (selectionChange)="onChangesFilterChange()">
                    <mat-option value="">All Changes</mat-option>
                    <mat-option value="1">No Changes</mat-option>
                    <mat-option value="2">No Changes(Y)</mat-option>
                    <mat-option value="3">Changes</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Status Filter Dropdown -->
              <div class="col-sm-12 col-md-3 col-lg-2 col-xxl-2 m-0">
                <!-- <mat-label class="field-label">Status Filter</mat-label> -->
                <mat-form-field class="w-100">
                  <mat-select name="selectedStatus" [(ngModel)]="selectedStatus"
                    (selectionChange)="onStatusFilterChange()">
                    <mat-option value="">All Status</mat-option>
                    <mat-option value="NOT STARTED">NOT STARTED</mat-option>
                    <mat-option value="IN PROGRESS">IN PROGRESS</mat-option>
                    <mat-option value="RETURNED">RETURNED</mat-option>
                    <mat-option value="SUBMITTED">SUBMITTED</mat-option>
                    <mat-option value="IN REVIEW">IN REVIEW</mat-option>
                    <mat-option value="APPROVED">APPROVED</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>

        </div>
        <mat-card-content>
          <!-- Data Table -->
          <!-- <div class="table-wrapper"> -->
          <table mat-table [dataSource]="contactsDs" class="applicants-table">
            <!-- Representative Name Column -->
            <ng-container matColumnDef="repname">
              <th mat-header-cell *matHeaderCellDef>Rep Name</th>
              <td mat-cell *matCellDef="let applicant">{{ applicant.fullName }}</td>
            </ng-container>

            <!-- Branch Column -->
            <ng-container matColumnDef="branch">
              <th mat-header-cell *matHeaderCellDef>Branch</th>
              <td mat-cell *matCellDef="let applicant">
                {{ applicant.branch }}
              </td>
            </ng-container>

            <!-- Start Date Column -->
            <ng-container matColumnDef="startDate">
              <th mat-header-cell *matHeaderCellDef>Start Date</th>
              <td mat-cell *matCellDef="let applicant">
                @if(applicant.startDatetime.startsWith('1000-01-01')){

                }@else{
                {{ applicant.startDatetime | date: 'dd MMM yyyy' }}
                }
              </td>
            </ng-container>

            <!-- End Date Column -->
            <ng-container matColumnDef="endDate">
              <th mat-header-cell *matHeaderCellDef>End Date</th>
              <td mat-cell *matCellDef="let applicant">
                @if(applicant.completionDatetime.startsWith('1000-01-01')){

                }@else{
                {{ applicant.completionDatetime | date: 'dd MMM yyyy' }}
                }
              </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="changes">
              <th mat-header-cell *matHeaderCellDef>Changes</th>
              <td mat-cell *matCellDef="let applicant">

                @if(applicant.userAnndeclarestatus != 'NOT STARTED'){
                @if(applicant.diferencecount === 0 && applicant.truecount === 0){
                <span class="status-chip no-changes">No Changes</span>
                } @else if (applicant.diferencecount === 0 && applicant.truecount > 0 ) {
                <span class="status-chip no-changesy"> {{ applicant.truecount }} No Changes(Y)</span>
                }
                @else{
                <span class="status-chip changes"> {{ applicant.diferencecount }} Changes</span>
                }
                }
              </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let applicant">
                <span [ngClass]="'status-chip ' + getStatusClass(applicant.userAnndeclarestatus)">
                  {{ applicant.userAnndeclarestatus }}
                </span>
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let applicant">
                <div class="row-actions">
                  @if(canView(applicant?.anndeclareStatus)){
                  <button mat-icon-button matTooltip="View" (click)="goToView(applicant)"
                    class="action-icon-btn view-btn">
                    <mat-icon>visibility</mat-icon>
                  </button>
                  }
                  @if (canReview(applicant?.anndeclareStatus)) {
                  <button mat-icon-button matTooltip="Review" (click)="goToReview(applicant)"
                    class="action-icon-btn edit-btn">
                    <mat-icon>edit</mat-icon>
                  </button>
                  }

                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" class="table-row"></tr>
          </table>
          <!-- </div> -->
        </mat-card-content>

        <!-- Paginator -->
        <div class="paginator-wrapper">
          <mat-paginator #paginator [pageSizeOptions]="[5, 10, 25, 50]" [pageSize]="5" showFirstLastButtons
            aria-label="Select page of recipients"></mat-paginator>
        </div>
      </mat-card>
    </div>
  </div>
</app-pias-layout>